import PropTypes from 'prop-types';
import React, { useContext } from 'react';
import { Context } from 'react-responsive';

export const ResponsiveProvider = ({ children, value }) => (
  <Context.Provider value={value}>
    {children}
  </Context.Provider>
);

ResponsiveProvider.propTypes = {
  children: PropTypes.node.isRequired,
  value: PropTypes.object,
};

export const useResponsiveContext = () => useContext(Context);
